<template>
  <svg
    :class="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_17008_118502)">
      <path
        d="M12.0003 24C13.4682 24 14.8743 23.736 16.1742 23.2536L16.696 12L16.1743 0.746391C14.8743 0.264047 13.4682 0 12.0003 0C10.5325 0 9.12639 0.264047 7.82645 0.746391L7.30469 12L7.82641 23.2536C9.12639 23.736 10.5325 24 12.0003 24Z"
        fill="#F0F0F0"
      />
      <path
        d="M0 11.9997C0 17.1593 3.2565 21.5578 7.82611 23.2533V0.746094C3.2565 2.44161 0 6.84012 0 11.9997Z"
        fill="#FF9811"
      />
      <path
        d="M16.1738 0.746094V23.2534C20.7434 21.5578 23.9999 17.1593 23.9999 11.9997C23.9999 6.84012 20.7434 2.44161 16.1738 0.746094V0.746094Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_17008_118502">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: 'h-5 w-5'
    }
  }
}
</script>
